<template>
    <div class="coface_agb">
        <div class="position_center md-layout-item" style="width:880px;">
            <h4 v-if="cofaceActivated" class="font_lg font_bold margin_title_bottom">
                <i class="fa fa-check valid_color" aria-hidden="true"></i>
                {{ $t("company.cofaceAGB.activated") }}
            </h4>
            <h4 v-else class="font_lg font_bold margin_title_bottom">
                {{ $t("company.tab.cofaceAGB") }}
            </h4>
            <div class="text_left light_bg_color">
                <p v-if="!cofaceActivated">{{$t("company.cofaceAGB.tip1")}}</p>
                <p>{{$t("company.cofaceAGB.tip2")}}</p>
                <ul class="tip_list">
                    <li v-for="n in 3" :key="n">
                        <i class="fa fa-minus font_sm" aria-hidden="true"></i>
                        {{$t(`company.cofaceAGB.tip2.list${n}`)}}
                    </li>
                </ul>
            </div>
            <p class="font_bold text_left sub-title">
                {{ $t("company.cofaceAGB.tip3.title") }}
            </p>
            <p class="text_left">
                {{ $t("company.cofaceAGB.tip3") }}
            </p>
            <p class="font_bold text_left">
                {{ $t("company.cofaceAGB.tip4") }}
            </p>
            <p class="font_bold text_left">
                {{ $t("company.cofaceAGB.tip5") }}
            </p>
            <p class="font_bold text_left">
                {{ $t("company.cofaceAGB.tip6") }}
            </p>
            <p class="text_left">
                {{ $t("company.cofaceAGB.tip7") }}
            </p>
            <p class="font_bold text_left">
                {{ $t("company.cofaceAGB.tip8.title") }}
            </p>
            <p class="font_bold text_left">
                {{ $t("company.cofaceAGB.tip8") }}
            </p>
            <p class="text_left">
                {{ $t("company.cofaceAGB.tip9") }}
            </p>
            <p class="text_left">
                {{ $t("company.cofaceAGB.tip10") }}
            </p>
            <div v-if="!cofaceActivated" class="flex flex_center" style="width:520px;margin:20px auto;">
				<md-button class="opacity_5 md-primary" @click="confirmSubmit">
					{{ $t("common.button.accept") }}
				</md-button>
            </div>
        </div>
    </div>
</template>

<script>
import {companyProfileApi} from "@/common/api/companyProfileApi";

export default {
		data() {
			return {
			    cofaceActivated: false
            }
		},
        mounted() {
			companyProfileApi.inspection.isCofaceToSAccepted().then(res => {
				this.cofaceActivated = res;
            })
        },
        methods: {
			confirmSubmit() {
				let option = {
					msg: this.$t("company.cofaceAGB.confirmSubmission"),
					confirmFun: this.submit,
					params: ""
				};

				this.confirmMeg(option, true);
            },
			submit() {
				companyProfileApi.operation.acceptCofaceTOS()
                    .then(() => {
                    	this.toastSuccess();
                    	this.cofaceActivated = true;
                    })
                    .catch(e => this.toast(e))
            }
        }
	};
</script>
<style lang="scss">
    .coface_agb {
        .sub-title {
            margin-top: 28px;
        }
        .tip_list {
            list-style: none;
            padding: 0;
            li:nth-of-type(2) {
                margin: 8px 0;
            }
            i {
                padding-right: 12px;
            }
        }
    }
</style>